<template>
  <v-list-item v-if="item" @mousedown="$emit('click')" link dense
    :class="[preselected ? 'selectedIndicator' : 'pl-3', !item.IsActive ? 'deletedcolor' : '', 'pr-0']"
    style="min-width:50px">
    <!-- Use mousdown and link instead of click to not catch bubbling click from preview button -->
    <v-list-item-icon class="my-auto mr-3">
      <v-icon :color="!item.IsActive ? '' : 'primary'" v-text="!item.IsActive ? 'mdi-domain-off' : 'mdi-domain'"
        :size="singleline ? 18 : 22" />
    </v-list-item-icon>
    <v-list-item-content style="padding-top: 6px; padding-bottom: 6px;">
      <v-list-item-title :class="!item.IsActive ? 'deactivated' : (preselected ? 'primary--text' : '')">
        {{ item.Id }}
        {{ item.Name }}
      </v-list-item-title>
      <template v-if="!singleline">
        <v-list-item-subtitle v-if="item && item.DefaultDeliveryAddress"
          v-text="[item.DefaultDeliveryAddress.Street,
          item.DefaultDeliveryAddress.Zip, item.DefaultDeliveryAddress.City, item.DefaultDeliveryAddress.County].join(' ')">
        </v-list-item-subtitle>
        <v-list-item-subtitle v-else style="opacity:0.5" v-text="$t('servicesystem.common_objects.commonterms.na')" />
      </template>
    </v-list-item-content>
    <v-scroll-x-transition>
      <v-list-item-action v-if="preselected === item.Id">
        <v-icon color="quaternary">mdi-check</v-icon>
      </v-list-item-action>
      <!--
      <v-list-item-action v-else-if="preselected">
        <v-btn @click.stop="$emit('useSelected')"
                color="primary">{{$t('servicesystem.common_objects.commonterms.use')}}</v-btn>
      </v-list-item-action>
      -->
    </v-scroll-x-transition>
    <v-scroll-x-transition v-if="previewable">
      <div :style="preselected ? '' : 'background-color: rgba(0, 0, 0, 0.02);'" style="align-self: stretch;">
        <v-list-item-action class="ma-0 d-flex align-center action" :class="preselected || 'inset'"
          style="height: 100%; pointer-events: all !important;">
          <v-btn tile style="height: 100%; background-color: transparent; min-width: 30px;" class="px-3"
            @mousedown.stop="" @click.stop="preselected ? $emit('closePreview') : $emit('openPreview')">
            <v-icon :color="preselected ? 'primary' : '#676767'" :size="preselected ? 18 : 20">
              {{ preselected ? ' mdi-arrow-collapse-right' : 'mdi-view-split-vertical' }}
            </v-icon>
          </v-btn>
        </v-list-item-action>
      </div>
    </v-scroll-x-transition>

  </v-list-item>
</template>


<script>
export default {
  name: "CustomerListItem",
  props: {
    item: Object,
    preselected: Boolean,
    previewable: Boolean,
    singleline: Boolean,
  },
  components: {},

  data: () => ({}),

  mounted() { },

  methods: {},

  computed: {},

  watch: {},
};
</script>

<style lang="scss" scoped>
.selectedIndicator {
  background-color: rgb(249, 249, 249) !important;
  z-index: 2;
  border: 1px solid #427aaf;
  border-left: 6px solid #427aaf;
  padding-left: 6px !important;
  border-right: none;
}

.action.inset {
  -moz-box-shadow: inset 7px 0 9px -7px var(--v-header-darken2) !important;
  -webkit-box-shadow: inset 7px 0 9px -7px var(--v-header-darken2) !important;
  box-shadow: inset 7px 0 9px -7px var(--v-header-darken2) !important;
}

.deactivated:not(:hover) {
  color: var(--v-disabled-darken2) !important;
  text-decoration: line-through !important;
}
</style>